import React from 'react';
import { ArrowDownToLineIcon, ExternalLinkIcon } from 'lucide-react';
import { Book } from '../types';
import { books } from '../data/books';
import { toDirect, toView } from '../data/links';
import { SectionHeading } from './SectionHeading';
const pad = (value: number) => String(value).padStart(2, '0');
function Thumb({
  book
}: {
  book: Book;
}) {
  if (book.cover) {
    return <img src={book.cover} alt={`Cover of Book ${pad(book.number)}, ${book.title}`} loading="lazy" className="h-full w-full object-cover" data-id="element-96" data-mp="2fnpas80zsvv9" />;
  }
  return <div className="flex h-full w-full flex-col justify-between p-2.5" style={{
    backgroundColor: '#102D4E',
    borderTop: `3px solid ${book.accent}`
  }} data-id="element-97" data-mp="2ofrc08ivyg6l">
      <span className="tnum font-sans text-[9px] tracking-[0.14em]" style={{
      color: book.accent
    }} data-id="element-98" data-mp="2te2lgi59qooa">
        {pad(book.number)}
      </span>
      <span className="font-display text-[11px] leading-tight text-paper" data-id="element-99" data-mp="33crzfzu1noz9">{book.title}</span>
    </div>;
}
export function BookGrid() {
  return <section aria-label="Your bonus book library" id="books" className="scroll-mt-24" data-id="element-100" data-mp="3svom0c5zxf0">
      <SectionHeading index="02" title="Your bonus book library" note="The original twelve-book collection, still yours. Open a book in your browser or download the whole PDF." data-id="element-101" data-mp="3uwu479c7k5oj">
        <span className="inline-flex items-center rounded-full bg-mist px-3 py-1.5 font-sans text-[11px] font-semibold tracking-[0.12em] text-navy" data-id="element-102" data-mp="3lyib90nvcvsx">
          {books.length} BOOKS INCLUDED
        </span>
      </SectionHeading>

      <ul className="mt-10 grid gap-4 lg:grid-cols-3" data-id="element-103" data-mp="hl1xr2gwh44y">
        {books.map(book => {
        const view = toView(book.file);
        const dl = toDirect(book.file);
        return <li key={book.number} className="flex gap-4 rounded-[18px] border border-navy/10 bg-white p-4" data-id="element-104" data-mp="8okv6nmlqekt">
              <div className="h-[104px] w-[74px] shrink-0 overflow-hidden rounded-[10px] border border-navy/10 bg-paper" data-id="element-105" data-mp="10giknx5btdrx">
                <Thumb book={book} data-id="element-106" data-mp="2upxg2hp44akr" />
              </div>

              <div className="flex min-w-0 flex-1 flex-col" data-id="element-107" data-mp="2zp1pn9fy8abm">
                <p className="tnum font-sans text-[10.5px] font-semibold tracking-[0.16em]" style={{
              color: book.accent
            }} data-id="element-108" data-mp="2zql3yui1obar">
                  BOOK {pad(book.number)}
                </p>
                <h3 className="mt-1 font-display text-[17px] font-semibold leading-snug text-navy" data-id="element-109" data-mp="2byeemfaql4ku">
                  {book.title}
                </h3>
                <p className="tnum mt-0.5 font-sans text-[12px] text-navy/45" data-id="element-110" data-mp="2gzbtahwjfghl">
                  {book.projectCount} projects
                </p>

                <div className="mt-auto flex flex-wrap items-center gap-2 pt-3" data-id="element-111" data-mp="26zb96tqugwcc">
                  <a href={view || undefined} target="_blank" rel="noreferrer" aria-disabled={!view} onClick={event => {
                if (!view) event.preventDefault();
              }} className={`inline-flex items-center gap-1.5 rounded-[10px] px-3 py-2 font-sans text-[12.5px] font-medium transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white ${view ? 'bg-navy text-paper hover:bg-[#0A2440]' : 'cursor-not-allowed bg-navy/20 text-navy/50'}`} data-id="element-112" data-mp="9mvlxabijzn">
                    <ExternalLinkIcon aria-hidden="true" className="h-3.5 w-3.5" strokeWidth={2} data-id="element-113" data-mp="2ifpplmnsn9re" />
                    Open book
                  </a>
                  {dl ? <a href={dl} className="inline-flex items-center gap-1.5 rounded-[10px] border border-navy/20 px-3 py-2 font-sans text-[12.5px] font-medium text-navy transition-colors duration-150 ease-out hover:border-navy/45 hover:bg-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-114" data-mp="o1597m6ia0dt">
                      <ArrowDownToLineIcon aria-hidden="true" className="h-3.5 w-3.5" strokeWidth={2} data-id="element-115" data-mp="uigfig8mbhe1" />
                      Download PDF
                    </a> : null}
                </div>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}